<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<div class="font-bold text-2xl z-30 relative bg-white text-center pb-40 pt-24"> Тілді таңдаңыз / Выберите язык</div>
<div class="flex w-1/2 mx-auto justify-around lang-buttons">
    <button
      (click)="setKzLang()"
      class="mx-auto w-1/3 hover:bg-black text-black-700 font-semibold hover:text-white py-2 px-4 border border-black hover:border-white rounded">
        Қазақ
    </button>
    <button
      (click)="setRuLang()"
      class="mx-auto w-1/3 hover:bg-black text-black-700 font-semibold hover:text-white py-2 px-4 border border-black hover:border-white rounded">
        Русский
    </button>
</div>
